<template>
  <div class="address-book-entry d-flex align-items-center">
    <div class="">
      <blockie v-if="publicKey" :address="publicKey" />
    </div>
    <div class="m-l-10 text-left">
      <a href="javascript:void(0)" @click="editAddressBookEntry()">
        <template v-if="userAddressBookItem(publicKey) && userAddressBookItem(publicKey).name !== 'NA'" href="javascript:void(0)">
          {{ userAddressBookItem(publicKey).name }}
        </template>
        <template v-else>
          (Click here to set name)
        </template>
      </a>
      <small class="form-text text-muted nowrap">{{ publicKey | hex_format(6, '....') }}<a @click="copyToClipboard(publicKey)"><img src="@/assets/images/copy.svg" class="copy-ico"></a></small>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Vue from 'vue'
import Blockie from './Blockie.vue'
import EventBus from '@/event-bus'

export default {
  name: 'AddressBookByPublicKey',
  components: { Blockie },
  props: ['publicKey'],
  data () {
    return {
      address_book_entry: null
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'userAddressBookItem', 'userAddressBook', 'activeGroup'])
  },
  watch: {
    userAddressBook () {
      if (!this.userAddressBookItem(this.publicKey)) {
        this.createAddressBookItem()
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      if (this.userAddressBook != null) {
        if (!this.userAddressBookItem(this.publicKey)) {
          this.createAddressBookItem()
        } else {
          this.address_book_entry = this.userAddressBookItem(this.publicKey).address_book_entry
        }
      }
    },
    async createAddressBookItem () {
      if (this.activeGroup !== 'null') {
        // create placeholder
        const placeholder = {
          address_book_entry: null,
          address_type: 'Unknown',
          name: 'NA',
          description: null,
          public_key: this.publicKey,
          group_id: null,
          did: null
        }

        Vue.set(this.userAddressBook, this.userAddressBook.length, placeholder)

        try {
          const result = await this.$api.get('/groups/group_by_account', {
            params: {
              account_id: this.publicKey
            }
          })
          if (result.data) {
            placeholder.address_type = 'Group'
            placeholder.name = result.data.name
            placeholder.group_id = result.data.group_id
          }
        } catch (e) {
          placeholder.address_type = 'Account'
        }
        const { data } = await this.$accounts.post('/addressbook/user', placeholder)

        this.userAddressBookItem(this.publicKey).address_book_entry = data.address_book_entry_db
        this.address_book_entry = data.address_book_entry_db
      }
    },

    editAddressBookEntry () {
      EventBus.$emit('addressBookPopup', this.address_book_entry)
    },

    copyToClipboard (textToCopy) {
      this.$copyText(textToCopy)
        .then(() => this.$toastr.s('Copied to clipboard', 'Success!'))
    }
  }
}
</script>

<style scoped>
.copy-ico {
  width: 10px;
  margin-left: 5px;
  cursor: pointer;
}
</style>
